import { CANADIAN_PROVINCES, US_STATES } from './states'

// Maps ISO alpha-2 Codes to countries that we support
export const COUNTRIES = [
  {
    id: 'CA',
    name: 'Canada',
    stateTerm: 'Province',
    states: () => {
      return CANADIAN_PROVINCES
    },
  },
  {
    id: 'US',
    name: 'United States of America',
    stateTerm: 'State',
    states: (isAllUSStates: any) => {
      if (isAllUSStates) {
        return US_STATES
      }
      return US_STATES.filter((state) => !state.isNonContiguousState)
    },
  },
]

export const getCountryFromCode = (code: string) => {
  return COUNTRIES.find((country) => country.id === code)
}

export const getCountryNameFromCode = (code: string) => {
  const countryInfo = getCountryFromCode(code)
  if (!countryInfo) {
    return ''
  }
  return countryInfo.name
}
